import { render, staticRenderFns } from "./ScreenFour.vue?vue&type=template&id=25b478c3&"
import script from "./ScreenFour.vue?vue&type=script&lang=js&"
export * from "./ScreenFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports